// How a line on the Fee Slips & Invoices page behaves once its status is changed.
//
// The list is grouped by status, so a new status moves the line to that group. It arrives
// there closed, so the open lines are the ones still being worked on (Emma, 16 Oct 2026) -
// except Email Clerk / Email Instructor on the admin page, which stays open with the email to
// write and send (Emma, 1 Nov 2026). Paid, Partial paid and Other used to stay open too; now
// they close, and a payment still to be saved says "not saved" on the closed line.

const EMAIL_ON_ADMIN = new Set(["email_clerk", "email_instructor"]);

export function staysOpenAfterStatus(status, { isAdminMode = false } = {}) {
  return isAdminMode && EMAIL_ON_ADMIN.has(status);
}
